"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HrElement = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const nano_theme_1 = require("nano-theme");
const slate_react_1 = require("slate-react");
const BasicButtonMore_1 = require("@jsonjoy.com/ui/lib/2-inline-block/BasicButton/BasicButtonMore");
const Popup_1 = require("@jsonjoy.com/ui/lib/4-card/Popup");
const HrLine_1 = require("./HrLine");
const HrOptionsPopup_1 = require("./HrOptionsPopup");
const VoidSelectionOverlay_1 = require("../VoidSelectionOverlay");
const settings = tslib_1.__importStar(require("./settings"));
const blockClass = (0, nano_theme_1.rule)({
    pos: 'relative',
    d: 'flex',
    ai: 'center',
    jc: 'center',
    bxz: 'border-box',
    us: 'none',
});
const innerClass = (0, nano_theme_1.rule)({
    d: 'flex',
    ai: 'center',
    jc: 'center',
    gap: '12px',
    w: '100%',
});
const textClass = (0, nano_theme_1.rule)({
    fz: '12px',
    lh: 1.4,
    maxW: '90%',
    ws: 'nowrap',
    ov: 'hidden',
    textOverflow: 'ellipsis',
});
const moreWrapClass = (0, nano_theme_1.rule)({
    pos: 'absolute',
    t: '50%',
    r: '-32px',
    tr: 'translateY(-50%)',
    trs: 'opacity .2s',
});
const HrElement = ({ attributes, children, element }) => {
    const theme = (0, nano_theme_1.useTheme)();
    const readOnly = (0, slate_react_1.useReadOnly)();
    const isSelected = (0, slate_react_1.useSelected)();
    const isFocused = (0, slate_react_1.useFocused)();
    const selected = isSelected && isFocused;
    const strokeWidth = settings.getHrStrokeWidth(element.strokeWidth);
    const lineWidth = settings.getHrLineWidth(element.lineWidth);
    const lineStyle = settings.getHrLineStyle(element.lineStyle);
    const blockHeight = settings.getHrBlockHeight(element.blockHeight);
    const caption = element.caption?.trim() ?? '';
    const lineColor = theme.g(0.7);
    const captionColor = theme.g(0.4);
    const preventMouseDown = React.useCallback((event) => {
        event.preventDefault();
        event.stopPropagation();
    }, []);
    return (React.createElement("div", { ...attributes, className: blockClass, style: {
            height: blockHeight,
            textAlign: element.align,
            borderRadius: 4,
        } },
        React.createElement("div", { contentEditable: false, className: innerClass, style: { width: `${lineWidth}%`, color: lineColor } }, caption ? (React.createElement(React.Fragment, null,
            React.createElement(HrLine_1.HrLine, { strokeWidth: strokeWidth, style: lineStyle }),
            React.createElement("span", { className: textClass, style: { color: captionColor } }, caption),
            React.createElement(HrLine_1.HrLine, { strokeWidth: strokeWidth, style: lineStyle }))) : (React.createElement(HrLine_1.HrLine, { strokeWidth: strokeWidth, style: lineStyle }))),
        React.createElement(VoidSelectionOverlay_1.VoidSelectionOverlay, { selected: selected }),
        !readOnly && (React.createElement("span", { contentEditable: false, className: moreWrapClass, style: { opacity: selected ? 1 : 0, pointerEvents: selected ? 'auto' : 'none' } },
            React.createElement(Popup_1.Popup, { renderContext: () => React.createElement(HrOptionsPopup_1.HrOptionsPopup, { element: element }) },
                React.createElement(BasicButtonMore_1.BasicButtonMore, { type: "button", width: 24, height: 24, rounder: true, tooltip: "Separator options", onMouseDown: preventMouseDown })))),
        children));
};
exports.HrElement = HrElement;
